import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import TextInput from './TextInput/TextInput'
import SearchHeaderSkeleton from './SearchHeaderSkeleton'

const SearchHeader = ({ results, onSearch, isLoading }) => {
  return (
    <SearchHeaderSkeleton
      nameSection={t('Search')}
      inputSection={
        <TextInput
          results={results}
          onSearch={onSearch}
          isLoading={isLoading}
        />
      }
    />
  )
}

SearchHeader.propTypes = {
  onSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  results: PropTypes.string,
}

export default SearchHeader
